import moment from 'moment'

export default function formatDate (date) {
  return moment(date).toISOString()
}



// WEBPACK FOOTER //
// ./app/mixpanel/formatDate.js